var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"mb-5 mt-4",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('form-caixa')],1),_c('b-col',{attrs:{"md":"6"}},[_c('table-caixas')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }